import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import ArcButton from '../ArcButton/index';
import dialog from './aidDialog.module.scss';

function Dialog(props) {
  const {
    width,
    height,
    visible,
    onOk,
    onCancel,
    maskClosable,
    children,
    btnStyle,
    ButtonCount,
  } = props;

  const {
    cancelBtnName,
    okBtnName,
    btnWidth,
    btnHeight,
    backgroundColor,
    centerWidth,
    BtnMarginBottom,
  } = btnStyle;

  const handlerCloseDialog = () => {
    if (!maskClosable) {
      onCancel();
    }
  };

  return (
    visible ? (
      ReactDOM.createPortal(
        <div
          aria-hidden
          className={dialog['dialog-content']}
          onClick={() => handlerCloseDialog()}
        >
          <div
            aria-hidden
            onClick={(event) => { event.stopPropagation(); }}
            className={dialog['modal-content']}
            style={{ width: `${width}px`, height: `${height}px` }}
          >
            <div className={dialog['modal-content']}>
              {children}
            </div>
            <div className={dialog['modal-footer']} style={{ marginBottom: BtnMarginBottom }}>
              {
                ButtonCount === 1
                  ? (
                    <ArcButton
                      text={okBtnName}
                      backgroundColor={backgroundColor[0]}
                      onClick={onCancel}
                      width={btnWidth}
                      height={btnHeight}
                      handleChecked={onOk}
                    />
                  )
                  : (
                    <>
                      <ArcButton
                        text={cancelBtnName}
                        backgroundColor={backgroundColor[0]}
                        onClick={onCancel}
                        width={btnWidth}
                        height={btnHeight}
                        handleChecked={onCancel}
                      />
                      <div style={{ width: centerWidth }} />
                      <ArcButton
                        text={okBtnName}
                        backgroundColor={backgroundColor[1]}
                        onClick={onOk}
                        width={btnWidth}
                        height={btnHeight}
                        handleChecked={onOk}
                      />
                    </>
                  )
              }
            </div>
          </div>
        </div>,
        document.body,
      )
    ) : null
  );
}

Dialog.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  visible: PropTypes.bool.isRequired,
  children: PropTypes.arrayOf(PropTypes.element),
  onCancel: PropTypes.func,
  onOk: PropTypes.func,
  maskClosable: PropTypes.bool,
  ButtonCount: PropTypes.number,
  btnStyle: PropTypes.objectOf({
    okBtnName: PropTypes.string,
    cancelBtnName: PropTypes.string,
    btnWidth: PropTypes.number,
    btnHeight: PropTypes.number,
    centerWidth: PropTypes.string,
    backgroundColor: PropTypes.array,
    BtnMarginBottom: PropTypes.string,
  }),
};

Dialog.defaultProps = {
  children: (null),
  onCancel: () => {}, // 点击取消按钮事件
  onOk: () => {}, // 点击确认按钮事件
  maskClosable: false, // 点击遮罩是否关闭弹框
  width: 520, // 弹框宽度
  height: 290, // 弹框高度
  ButtonCount: 2, // 设置底部按钮个数
  btnStyle: { // 底部按钮文字样式设置
    okBtnName: '',
    cancelBtnName: '',
    btnWidth: 160,
    btnHeight: 52,
    centerWidth: '10px',
    backgroundColor: ['#ffffff', '#0058b3'],
    BtnMarginBottom: '30px',
  },
};

export default Dialog;
